(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["smart-pot-factory-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smart-pot-factory-film')) {
  customElements.define('smart-pot-factory-film', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.stopped = false;
      this.visible = false;
      this.video.muted = true;
      this.button.hidden = false;
      const update = () => {
        this.button.querySelector('[data-film-label]').textContent = this.video.paused ? this.button.dataset.play : this.button.dataset.pause;
        this.button.querySelector('[data-film-icon]').textContent = this.video.paused ? '▶' : 'Ⅱ';
      };
      const play = () => this.video.play().catch(update);
      const sync = () => {
        if (this.visible && !document.hidden && !this.stopped && !this.motion.matches && !navigator.connection?.saveData) play();
        else this.video.pause();
      };
      this.video.addEventListener('play', update, options);
      this.video.addEventListener('pause', update, options);
      this.video.addEventListener('error', () => { this.button.hidden = true; }, options);
      this.button.addEventListener('click', () => {
        this.stopped = !this.video.paused;
        if (this.video.paused) play(); else this.video.pause();
      }, options);
      this.motion.addEventListener('change', sync, options);
      document.addEventListener('visibilitychange', sync, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        sync();
      }, { threshold: 0.15 });
      this.observer.observe(this);
      update();
    }
    disconnectedCallback() {
      this.video?.pause();
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-pot-live-support"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('smart-pot-support'))customElements.define('smart-pot-support',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.querySelector('[data-open-chat]')?.addEventListener('click',event=>{const launcher=document.querySelector('shopify-chat')?.shadowRoot?.querySelector('button[part="activator"]');if(launcher){event.preventDefault();if(launcher.getAttribute('aria-expanded')!=='true')launcher.click();}else if(window.ShopifyInbox&&typeof window.ShopifyInbox.open==='function'){event.preventDefault();window.ShopifyInbox.open();}});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-pot-rolling-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smart-pot-rolling-banner')) {
  customElements.define('smart-pot-rolling-banner', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button || this.controller) return;
      this.controller = new AbortController();
      button.hidden = false;
      this.querySelectorAll('a').forEach(link => link.addEventListener('focus', () => {
        this.querySelector('.sp-rolling__window').scrollLeft = link.offsetLeft;
      }, {signal:this.controller.signal}));
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) this.querySelector('.sp-rolling__window').scrollLeft = 0;
      }, {signal:this.controller.signal});
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-label', paused ? button.dataset.play : button.dataset.pause);
        button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-pot-shop-catalog"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smart-pot-catalog')) {
  customElements.define('smart-pot-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.category = 'all';
      this.grid = this.querySelector('[data-grid]');
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.search = this.querySelector('[data-search]');
      this.sort = this.querySelector('[data-sort]');
      this.links = [...this.querySelectorAll('[data-category]')];
      this.querySelector('[data-controls]').hidden = false;
      this.links.forEach(link => link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.category = link.dataset.category;
        this.search.value = '';
        this.update();
        this.dispatchEvent(new CustomEvent('smart-pot:category-select', {bubbles:true,detail:{category:link.textContent.trim()}}));
      }));
      this.search.addEventListener('input', () => this.update());
      this.sort.addEventListener('change', () => this.update());
      this.querySelector('[data-reset]').addEventListener('click', () => {
        this.category = 'all'; this.search.value = ''; this.sort.value = 'featured'; this.update(); this.search.focus();
      });
      this.update();
    }
    update() {
      const term = this.search.value.trim().toLowerCase();
      let count = 0;
      this.links.forEach(link => {
        const active = link.dataset.category === this.category;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
      });
      const price = card => Number(card.querySelector('[data-sp-price]')?.dataset.spPrice || 0);
      const sorted = [...this.cards].sort((a,b) => {
        if (this.sort.value === 'price-asc') return price(a)-price(b);
        if (this.sort.value === 'price-desc') return price(b)-price(a);
        if (this.sort.value === 'title') return a.dataset.title.localeCompare(b.dataset.title);
        return Number(a.dataset.order)-Number(b.dataset.order);
      });
      sorted.forEach(card => {
        const categoryMatch = this.category === 'all' || card.dataset.categories.split(/\s+/).includes(this.category);
        card.hidden = !categoryMatch || !card.dataset.title.toLowerCase().includes(term);
        if (!card.hidden) count++;
        this.grid.append(card);
      });
      this.querySelector('[data-count]').textContent = `${count} ${count === 1 ? this.dataset.singleLabel : this.dataset.countLabel}`;
      this.querySelector('[data-empty]').hidden = count > 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smart-pot-size-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('smart-pot-size-shop')) {
  customElements.define('smart-pot-size-shop', class extends HTMLElement {
    connectedCallback() {
      this.start = () => this.mount();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, {once:true});
      else this.mount();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.start);
      this.observer?.disconnect();
      this.main?.removeEventListener('change', this.onChange, true);
      this.field?.querySelectorAll('input[type=radio]').forEach(input => {
        input.removeAttribute('data-sp-filtered');input.removeAttribute('aria-describedby');
        const label = this.field.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        label?.removeAttribute('data-sp-filtered');label?.querySelector('[data-sp-sale-badge]')?.remove();
        const name = label?.querySelector('span');if(name) name.textContent = input.value;
      });
      this.ui?.remove(); this.subtitle?.remove(); this.benefits?.remove();
      this.ui = null;
      this.main?.classList.remove('sp-fabric-product');
    }
    mount() {
      if (this.ui) return;
      this.main = document.querySelector('.main-product');
      this.info = this.main?.querySelector('[id^="ProductInfo-"]');
      this.picker = this.info?.querySelector('.x-variant-picker');
      this.field = this.picker?.querySelector('fieldset[data-option-name="size"]');
      if (!this.field) return;
      try {this.data = JSON.parse(this.querySelector('[data-sp-shopping-data]').textContent);} catch (_) {return;}
      // Keep the native selector unchanged if a future catalog exceeds this complete data set.
      if (!this.data.variants.length || this.data.count > this.data.variants.length) return;
      this.sizeIndex = this.data.sizeIndex;
      this.ui = this.querySelector('[data-sp-shopping-ui]').content.firstElementChild.cloneNode(true);
      this.picker.before(this.ui);
      this.main.classList.add('sp-fabric-product');
      this.subtitle = this.querySelector('[data-sp-subtitle]').content.firstElementChild.cloneNode(true);
      this.info.querySelector('.x-block-product-title')?.append(this.subtitle);
      const quantity = this.info.querySelector('.product-form__quantity');
      const price = this.info.querySelector('.x-block-price');
      if (quantity && price) quantity.before(price);
      this.specs = this.info.querySelector('[data-smart-pot-size-details]');
      const delivery = this.info.querySelector('.x-block-estimate-delivery');
      const buy = this.info.querySelector('.x-block-buy-buttons');
      if (buy && delivery) buy.after(delivery);
      const inventory = this.info.querySelector('.x-block-inventory-status');
      if (buy && inventory) buy.after(inventory);
      this.benefits = this.querySelector('[data-sp-benefits]').content.firstElementChild.cloneNode(true);
      // Use the existing media column, preserving all zoom and thumbnail controls.
      const media = this.main.querySelector('.product-media-container');
      if (media) media.append(this.benefits);
      else {this.info.querySelector('.x-block-description')?.before(this.benefits);}
      this.groupButtons = [...this.ui.querySelectorAll('[data-sp-filter="group"]')];
      const selectedSize = parseFloat(this.field.querySelector('input:checked')?.value);
      this.filter = this.groupButtons.find(b => selectedSize >= Number(b.dataset.min) && selectedSize <= Number(b.dataset.max)) || 'all';
      this.ui.addEventListener('click', e => {
        const button = e.target.closest('[data-sp-filter]');
        if (!button) return;
        this.filter = button.dataset.spFilter === 'group' ? button : button.dataset.spFilter;
        this.refresh();
      });
      this.onChange = event => {this.resolveSelection(event);requestAnimationFrame(() => this.refresh());};
      this.main.addEventListener('change', this.onChange, true);
      this.observer = new MutationObserver(() => this.refresh());
      this.refresh();
    }
    resolveSelection(event) {
      const input = event.target;
      if (!input.matches('fieldset input[type="radio"]') || !this.picker.contains(input)) return;
      const fields = [...this.picker.querySelectorAll('fieldset')];
      const changedIndex = fields.indexOf(input.closest('fieldset'));
      const selected = fields.map(field => field.querySelector('input:checked')?.value);
      this.adjustment = '';
      if (changedIndex < 0 || this.data.variants.some(v => v.available && v.options.every((o,i) => o === selected[i]))) return;
      // Always honor the option just chosen. When changing color/handles, also preserve size.
      const candidates = this.data.variants.filter(v => v.available && v.options[changedIndex] === input.value && (changedIndex === this.sizeIndex || v.options[this.sizeIndex] === selected[this.sizeIndex]));
      const score = v => v.options.reduce((total,value,index) => total + (value === selected[index] ? 1 : 0), 0);
      candidates.sort((a,b) => score(b) - score(a));
      const target = candidates[0];
      const resource = this.picker.querySelector(`script[data-resource="${CSS.escape(input.id)}"]`);
      if (!target?.native || !resource) return;
      const targetInputs = fields.map((field,index) => [...field.querySelectorAll('input[type="radio"]')].find(radio => radio.value === target.options[index]));
      if (targetInputs.some(radio => !radio || !radio.dataset.optionValueId)) return;
      const changes = target.options.filter((value,index) => value !== selected[index]);
      targetInputs.forEach(radio => {radio.checked = true;});
      resource.textContent = JSON.stringify(target.native);
      this.adjustment = `${this.data.labels.adjusted} ${changes.join(' · ')}.`;
    }
    refresh() {
      this.observer?.disconnect();
      this.field = this.picker.querySelector('fieldset[data-option-name="size"]');
      if (!this.field) return;
      const inputs = [...this.field.querySelectorAll('input[type="radio"]')];
      const options = [...this.picker.querySelectorAll('fieldset')].map(f => f.querySelector('input:checked')?.value);
      const saleVariants = this.data.variants.filter(v => v.available && v.original > v.price);
      const saleSizes = new Set(saleVariants.map(v => v.options[this.sizeIndex]));
      const sizes = inputs.map(i => parseFloat(i.value)).filter(Number.isFinite);
      this.ui.querySelector('[data-sp-sale-callout]').hidden = !saleSizes.size;
      if (this.filter === 'sale' && !saleSizes.size) this.filter = 'all';
      this.groupButtons.forEach(button => {
        const range = sizes.filter(n => n >= Number(button.dataset.min) && n <= Number(button.dataset.max));
        button.hidden = !range.length;
        button.querySelector('[data-sp-range]').textContent = range.length ? `${Math.min(...range)}–${Math.max(...range)} gal` : '';
        button.querySelector('[data-sp-group-sale]').hidden = ![...saleSizes].some(s => parseFloat(s) >= Number(button.dataset.min) && parseFloat(s) <= Number(button.dataset.max));
        button.setAttribute('aria-pressed', String(this.filter === button));
      });
      this.ui.querySelector('[data-sp-filter="all"]').setAttribute('aria-pressed', String(this.filter === 'all'));
      this.ui.querySelector('[data-sp-filter="sale"]').setAttribute('aria-pressed', String(this.filter === 'sale'));
      const ordered = [...inputs].sort((a,b) => parseFloat(a.value) - parseFloat(b.value));
      const update = () => {
        ordered.forEach(input => {
          const label = this.field.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          if (!label) return;
          const name = label.querySelector('span:not([data-sp-sale-badge])');
          if (name) name.textContent = `${parseFloat(input.value)} gal`;
          if (!this.field.dataset.spSorted) {this.field.append(input, label);}
          const number = parseFloat(input.value);
          const shown = this.filter === 'all' || (this.filter === 'sale' ? saleSizes.has(input.value) : number >= Number(this.filter.dataset.min) && number <= Number(this.filter.dataset.max));
          [input,label].forEach(n => n.toggleAttribute('data-sp-filtered', !shown));
          let badge = label.querySelector('[data-sp-sale-badge]');
          if (saleSizes.has(input.value)) {
            if (!badge) {badge = document.createElement('span');badge.className = 'sp-size-sale';badge.dataset.spSaleBadge = '';badge.id = `${input.id}-sale`;label.append(badge);input.setAttribute('aria-describedby', badge.id);}
            const matching = saleVariants.some(v => v.options.every((o,index) => index === this.sizeIndex ? o === input.value : o === options[index]));
            badge.textContent = matching ? this.data.labels.sale : this.data.labels.saleOptions;
          } else {badge?.remove();input.removeAttribute('aria-describedby');}
        });
        this.field.dataset.spSorted = 'true';
        if (this.specs && this.field.nextElementSibling !== this.specs) this.field.after(this.specs);
      };
      if (window.Alpine?.mutateDom) window.Alpine.mutateDom(update); else update();
      const selected = this.field.querySelector('input:checked');
      const suffix = selected?.hasAttribute('data-sp-filtered') ? ` ${this.data.labels.choose}` : '';
      this.ui.querySelector('[data-sp-selection]').textContent = `${this.data.labels.selected} ${options.filter(Boolean).join(' · ')}.${suffix}${this.adjustment ? ' ' + this.adjustment : ''}`;
      this.observer?.observe(this.picker, {childList:true,subtree:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
